import React from 'react';
import classNames from "classnames";
import styles from "../styles/language-menu.module.scss";
import {observer} from 'mobx-react';
import {LanguageMenuModuleItems} from "./language-menu-module.items";

export const LanguageMenuModuleContent = observer(({controller}) => {
  const {state} = controller;
  const {isMenuOpen, menuModel} = state;
  const {shouldArrowOpenMenu} = menuModel;
  const shouldRenderItemList: Boolean = shouldArrowOpenMenu && isMenuOpen;

  return (
    shouldRenderItemList ? <div className={classNames(styles.content)}>
      <div className={classNames(styles.items)}>
        <LanguageMenuModuleItems controller={controller}/>
      </div>
    </div> : null
  )
});